import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormWrapper } from "../../components";
import { useApiService } from "../../hooks";
import "./Header.css";

const Header = () => {
  const [user, setUser] = useState({ name: "Full Name", username: "admin" });
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const { get } = useApiService();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResponse, setSearchResponse] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const handleSearchSubmit = async (e) => {
    e.preventDefault();

    const response = await get(`/api/search?query=${searchQuery}`);
    setSearchResponse(() =>
      response.map((item) => {
        const linkSplit = item.link.split("?");
        const [paramName, paramValue] = linkSplit[1]?.split("=") || [null, null];
        return {
          type: item.type,
          result: paramValue
            ? `${item.result.replace("()", `(${paramName.toUpperCase()}: ${paramValue})`)} `
            : item.result,
          link: item.link,
        };
      })
    );
    setShowSearchDropdown(true);
  };

  const mailRef = useRef();
  const searchRef = useRef();
  const searchResponseRef = useRef();
  const handleOutsideClick = (e) => {
    if (searchRef.current && !searchRef.current.contains(e.target)) {
      setShowSearchDropdown(false);
      setSearchQuery("");
      setSearchResponse([]);
    }

    if (mailRef.current && !mailRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    setShowDropdown(false);
    setShowSearchDropdown(false);
    setSearchQuery("");
    setSearchResponse([]);
  }, []);

  const navigate = useNavigate();

  const handleSearchResultNavigate = (link) => {
    setShowSearchDropdown(!showSearchDropdown);
    setShowDropdown(false);
    setSearchQuery("");
    setSearchResponse([]);
    navigate(link);
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="header__search">
        <span className="header__search-icon">
          <Icon icon="mingcute:search-line" inline />
        </span>
        <FormWrapper form="search_form" onSubmit={handleSearchSubmit}>
          <input
            type="search"
            placeholder="Search"
            className="header__search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            maxLength={50}
          />
        </FormWrapper>
        {showSearchDropdown && (
          <div className="header_search-dropdown" ref={searchRef}>
            {searchResponse.length > 0 ? (
              searchResponse.map((item) => (
                <div key={item.id} className="header_search-dropdown-item">
                  <button className="search_result" onClick={() => handleSearchResultNavigate(item.link)}>
                    <span className="search_result-name">{item.result}</span>
                    <span className="small gray search_result-type">Search {item.type}</span>
                  </button>
                  {/* <Link
                    to={item.link}
                    ref={searchResponseRef}
                    className="header_search-dropdown-item-link row"
                    onClick={() => setShowSearchDropdown(false)}
                  >
                    <span className="header_search-dropdown-item-name">{item.result}</span>
                    <span className="small gray header_search-dropdown-item-type">Search {item.type}</span>
                  </Link> */}
                </div>
              ))
            ) : (
              <div className="small gray">No results found</div>
            )}
          </div>
        )}
      </div>
      <div className="header__user">
        <div className="header__icons">
          <div className="notification_wrapper">
            {/* <span className="header__icon" onClick={() => setShowDropdown((prev) => !prev)}>
              <Icon icon="material-symbols:mail-outline" />
            </span> */}
            <span className="header__icon" onClick={() => setShowDropdown((prev) => !prev)}>
              <Icon icon="carbon:notification" inline />
            </span>
            {showDropdown && (
              <div ref={mailRef} className="notification_dropdown">
                <p className="label gray">Coming Soon...</p>
              </div>
            )}
          </div>
        </div>
        <div className="header__profile">
          {/* <Icon icon="fluent-emoji:man-light" className="header__profile-icon" /> */}
          <div className="header__profile-image">
            <img src="/assets/images/A.svg" alt="Aurus" />
          </div>
          <div className="header__profile-info">
            <span className="header__profile-name">Aurus Admin</span>
            {/* <span className="header__profile-username">{user.username ?? "Admin"}</span> */}
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
